import Section from "./Section";

const offers = [
    {
        title: "Manual Testing",
        desc: "Ensure real world reliability with structured manual QA testing. Our expert testers simulate actual user behavior to uncover critical issues, improve user experience, and help your team release with confidence.",
        icon: "📝",
    },
    {
        title: "Automation Testing",
        desc: "Accelerate delivery with scalable test automation. We build robust frameworks tailored to your tech stack helping you reduce release cycles, catch regressions early, and drive long term QA efficiency.",
        icon: "🤖",
    },
    {
        title: "Consultation",
        desc: "Transform QA from a cost center into a growth driver. Our consultation services guide your team in process optimization, tooling, and shift left strategies to help you scale quality without slowing innovation.",
        icon: "🧑",
    },
];

const OfferCard = ({ offer, delay, visible }) => {
    return (
        <div
            className={`offer-card ${visible ? "animate" : ""}`}
            style={{
                animationDelay: visible ? `${0.2 + delay}s` : "0s",
            }}
        >
            <div
                className={`offer-inner ${visible ? "animate-inner" : ""}`}
                style={{
                    animationDelay: visible ? `${0.7 + delay}s` : "0s",
                }}
            >
                <div className="offer-icon">{offer.icon}</div>
                <h3>{offer.title}</h3>
                <p>{offer.desc}</p>
            </div>
        </div>
    );
};

const ServiceSection = () => {
    return (
        <Section id="services" label="Service" bgClass="">
            {(visible) => (
                <div className="section-content">
                    <div className="section-left">
                        <div className="left-content-box">
                            <div className="text-bg">
                                <h2
                                    className={`left-title ${
                                        visible ? "animate-title" : ""
                                    }`}
                                    style={{
                                        animationDelay: visible ? "0.2s" : "0s",
                                    }}
                                >
                                    Software Test Services to Take Your Software to Higher
                                    Quality
                                </h2>
                                <p
                                    className={`left-desc ${
                                        visible ? "animate-desc" : ""
                                    }`}
                                    style={{
                                        animationDelay: visible ? "0.7s" : "0s", // 0.5s after title
                                    }}
                                >
                                    Deliver software with confidence. Shift Left helps you integrate QA early, streamline testing, and scale quality so your team ships faster, safer, and smarter.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="section-divider" />

                    <div className="section-right">
                        <div className="services-offers">
                            {offers.map((offer, idx) => (
                                <OfferCard
                                    key={idx}
                                    offer={offer}
                                    delay={0.2 * idx}
                                    visible={visible}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </Section>
    );
};

export default ServiceSection;
